import { CloseOutlined } from "@mui/icons-material";
import { Dialog, IconButton } from "@mui/material";
import useMedia from "../lib/hooks/useMedia";
import useWalletConnect from "../lib/hooks/useWalletConnect";
import clsx from "clsx";
import Metamask from "../assets/metamask.png";
import Trust from "../assets/trust.png";

function MetaMaskCard(props: { onClick: () => void }) {
  return (
    <div
      onClick={props.onClick}
      className="space-y-4 h-full w-full hover:bg-gray-300 rounded-md cursor-pointer transition duration-150 flex flex-col items-center justify-center"
    >
      <img src={Metamask} alt="MetaMask" className="w-40" />
    </div>
  );
}

function WalletConnectCard(props: { onClick: () => void }) {
  return (
    <div
      onClick={props.onClick}
      className="space-y-4 p-8 hover:bg-gray-300 rounded-md cursor-pointer transition duration-150 flex flex-col items-center justify-center"
    >
      <img
        src="data:image/svg+xml;base64,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"
        alt="WalletConnect"
        className="w-20"
      />
      <div className="space-y-0 text-center">
        <div className="font-bold text-lg text-white">WalletConnect</div>
      </div>
    </div>
  );
}

function TrustWalletCard(props: { onClick: () => void }) {
  return (
    <div
      onClick={props.onClick}
      className="space-y-4 hover:bg-gray-300 rounded-md cursor-pointer transition duration-150 flex flex-col items-center justify-center"
    >
      <img src={Trust} alt="MetaMask" className="w-40" />
    </div>
  );
}

export default function WalletConnectDialog() {
  const {
    open,
    closeWalletConnect,
    onConnectInjected,
    onConnectWalletConnect,
  } = useWalletConnect();
  const { matchesDesktop } = useMedia();
  return (
    <Dialog
      open={open}
      fullScreen={!matchesDesktop}
      onClose={closeWalletConnect}
      PaperProps={{
        style: {
          background: "transparent",
        },
      }}
    >
      <div
        className={clsx("p-4 space-y-4 rounded-md bg-black", {
          "h-full": !matchesDesktop,
        })}
        style={{ minWidth: 320 }}
      >
        <div className="flex items-center justify-between w-full">
          <div>
            <div className="text-xl font-bold text-white">Connect Wallet</div>
          </div>
          <IconButton onClick={closeWalletConnect}>
            <CloseOutlined color="inherit" className="text-white" />
          </IconButton>
        </div>
        <div className={clsx("grid gap-8", {
          "grid-cols-1": !matchesDesktop,
          "grid-cols-2": matchesDesktop,
        })}>
          <MetaMaskCard onClick={onConnectInjected} />

          {!matchesDesktop && <TrustWalletCard onClick={onConnectInjected} />}

          <WalletConnectCard onClick={onConnectWalletConnect} />
        </div>
      </div>
    </Dialog>
  );
}
